export default __webpack_public_path__ + "54409d8e1020532d6df505616c0c7dbb.svg";